import React from 'react';
import { Button, Form, Header, Segment, Input, Select } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class CreateCourse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            maxNumberOfStudents: null,
            comment: null,
            commentForStaff: null,
            courseCode: null,
            ects: null,
            lectureNumber: null,
            exerciseNumber: null,
            semesterId: '',
            semesters: [],
            academicYears: [],
            academicYearId: '',
            currentAcademicYear: '', // current by date

            courseCodeErr: false,
            ectsErr: false,
            lectureNumberErr: false,
            exerciseNumberErr: false,
            semesterIdErr: false,

            disabledButton: false
        };

        this.createCourse = this.createCourse.bind(this);
        this.closeCreateCourseMode = this.closeCreateCourseMode.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getSemesters = this.getSemesters.bind(this);
    }

    componentDidMount() {
        if (this.props.edit) {
            this.setState({
                comment: this.props.courseImplementation ? this.props.courseImplementation.comment : null,
                commentForStaff: this.props.courseImplementation ? this.props.courseImplementation.commentForStaff : null
            });
        }

        axios.get('/academic-years/current').then((res) => {
            this.setState({ academicYearId: res.data.id, currentAcademicYear: res.data });
        }).then(() => {
            axios.get('academic-years')
                .then(res => {
                    let academicYears = res.data.reverse().map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    })).filter(el => {
                        // only this year and next year
                        const nextAcademicYearStart = this.state.currentAcademicYear.startYear + 1;
                        if (this.props.enableAddForPreviousYears) {
                            return el.startYear <= nextAcademicYearStart; // treci ciklus
                        } else {
                            return el.startYear === this.state.currentAcademicYear.startYear ||
                                el.startYear === nextAcademicYearStart;
                        }
                    });
                    this.setState({
                        academicYears
                    });

                    axios.get(`semester/by-academic-year/${this.state.academicYearId}`)
                        .then(res => {
                            this.setState({
                                semesters: res.data.map(el => ({
                                    ...el, key: el.name._key, value: el.id, text: el.name.name + ' ' + el.academicYear.name
                                })).filter(el => el.earlyEnrollmentStartDate < Date.now())
                            });
                        });
                })
                .catch(err => {
                    console.log('Failed to fetch academic years or semesters.');
                });
        });
    }

    createCourse(maxNumberOfStudents, comment, courseCode, exerciseNumber, lectureNumber, ects, semesterId, commentForStaff) {
        let courseBasicId = localStorage.getItem('courseBasicId');
        let courseImplObj = {
            maxNumberOfStudents,
            courseBasicId,
            courseCode,
            comment,
            lectureNumber,
            exerciseNumber,
            ects,
            semesterId,
            commentForStaff
        };

        if (!semesterId) {
            if (!semesterId) { this.setState({ semesterIdErr: true }); } else { this.setState({ semesterIdErr: false }); }
            toast('Niste unijeli sva obavezna polja!');
        } else {
            axios.post('course/add-implementation', { ...courseImplObj })
                .then(res => {
                    toast('Uspješno ste kreirali implementaciju predmeta');
                    this.props.updateData(this.state.academicYearId);

                })
                .catch(err => {
                    if (err.response.data === 'This course implementation is already created!') {
                        toast('Implementacija predmeta u odabranom semestru je već kreirana!');
                    } else {
                        toast('Došlo je do greške! Kreiranje implementacije predmeta nije uspjelo.');
                    }
                });
        }
    }

    closeCreateCourseMode() {
        this.setState({
            maxNumberOfStudents: null, comment: null, commentForStaff: null, courseCode: null, ects: null, exerciseNumber: null, lectureNumber: null, semesterId: null, disabledButton: false
        });
        this.props.closeCreateCourseMode();
    }

    getSemesters(id) {
        axios.get(`semester/by-academic-year/${id}`)
            .then(res => {
                this.setState({
                    semesters: res.data.map(el => ({
                        ...el, key: el.name._key, value: el.id, text: el.name.name + ' ' + el.academicYear.name
                    })).filter(el => {
                        const nextAcademicYearStart = this.state.currentAcademicYear.startYear + 1;
                        if (el.academicYear.startYear > nextAcademicYearStart) {
                            return false;
                        } else if (el.academicYear.startYear === nextAcademicYearStart) {
                            // for next year only return the winter semester!
                            return el.name._key === 'winter semester';
                        } else return true;
                    })
                });
            });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'academicYearId') {
            this.getSemesters(value);
        }
        this.setState({
            [name]: value
        });
    }


    render() {
        return (

            this.props.secondary ?
                <Segment clearing secondary>
                    <Form noValidate>
                        <Form.Group widths="equal">
                            { !this.props.edit && <Form.Field
                                required
                                control={Select}
                                label="Akademska godina"
                                placeholder="Odaberite akademsku godinu"
                                value={this.state.academicYearId}
                                name="academicYearId"
                                options={this.state.academicYears}
                                onChange={this.handleInputChange}
                            />}
                            {!this.props.edit && <Form.Field
                                required
                                control={Select}
                                label="Semestar"
                                placeholder="Odaberite semester"
                                value={this.state.semesterId}
                                name="semesterId"
                                options={this.state.semesters.filter(e => e.key !== 'other' && e.key !== 'summer school')}
                                onChange={this.handleInputChange}
                                error={this.state.semesterIdErr}
                            />}
                            <Form.Field>
                                <label>Napomena</label>
                                <Form.Input
                                    placeholder="Unesite napomenu..."
                                    rows={1}
                                    value={this.state.comment}
                                    onChange={(e) => this.setState({ comment: e.target.value })}
                                />
                            </Form.Field>
                            <Form.Field>
                                <label>Napomena za profesora</label>
                                <Form.Input
                                    placeholder="Unesite napomenu..."
                                    rows={1}
                                    value={this.state.commentForStaff}
                                    onChange={(e) => this.setState({ commentForStaff: e.target.value })}
                                />
                            </Form.Field>

                        </Form.Group>


                        <Button basic="true" color="blue" onClick={this.closeCreateCourseMode} floated="right">Odustani</Button>
                        <Button
                            color="blue"
                            floated="right"
                            onClick={
                                () => {
                                    if (this.props.edit) { this.props.editImplementation(this.state.comment, this.state.commentForStaff); } else {
                                        this.createCourse(
                                            this.state.maxNumberOfStudents,
                                            this.state.comment,
                                            this.state.courseCode,
                                            this.state.exerciseNumber,
                                            this.state.lectureNumber,
                                            this.state.ects,
                                            this.state.semesterId,
                                            this.state.commentForStaff

                                        );
                                    }
                                }
                            }
                        >
                            {this.props.edit ? 'Izmijeni' : 'Kreiraj'}
                        </Button>

                    </Form>
                </Segment> : <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            Kreiranje implementacije predmeta
                        </Header>
                    </Segment>
                    <Segment clearing>
                        <Form noValidate>
                            {!this.props.edit && <Form.Group widths="equal">
                                <Form.Field
                                    required
                                    control={Select}
                                    label="Akademska godina"
                                    placeholder="Odaberite akademsku godinu"
                                    value={this.state.academicYearId}
                                    name="academicYearId"
                                    options={this.state.academicYears}
                                    onChange={this.handleInputChange}
                                />
                                <Form.Field
                                    required
                                    control={Select}
                                    label="Semestar"
                                    placeholder="Odaberite semester"
                                    value={this.state.semesterId}
                                    name="semesterId"
                                    options={this.state.semesters.filter(e => e.key !== 'other' && e.key !== 'summer school')}
                                    onChange={this.handleInputChange}
                                    error={this.state.semesterIdErr}
                                />
                            </Form.Group>}
                            {/* <Form.Group widths="equal"> */}
                            {/* <Form.Field */}
                            {/* control={Input} */}
                            {/* label="Maksimalan broj studenata" */}
                            {/* placeholder="Unesite maksimalan broj studenata" */}
                            {/* value={this.state.maxNumberOfStudents} */}
                            {/* name="maxNumberOfStudents" */}
                            {/* onChange={(e) => this.setState({ maxNumberOfStudents: e.target.value })} */}
                            {/* /> */}
                            {/* <Form.Field */}
                            {/* control={Input} */}
                            {/* label="Šifra implementacije predmeta" */}
                            {/* placeholder="Unesite šifru" */}
                            {/* value={this.state.courseCode} */}
                            {/* name="courseCode" */}
                            {/* onChange={(e) => this.setState({ courseCode: e.target.value })} */}
                            {/* error={this.state.courseCodeErr} */}
                            {/* /> */}
                            {/* </Form.Group> */}

                            {/* <Form.Group widths="equal"> */}
                            {/* <Form.Field */}
                            {/* control={Input} */}
                            {/* label="Vježbe (broj sati)" */}
                            {/* placeholder="Unesite broj sati" */}
                            {/* value={this.state.exerciseNumber} */}
                            {/* name="exerciseNumber" */}
                            {/* onChange={(e) => this.setState({ exerciseNumber: e.target.value })} */}
                            {/* error={this.state.exerciseNumberErr} */}
                            {/* /> */}
                            {/* <Form.Field */}
                            {/* control={Input} */}
                            {/* label="Predavanja (broj sati)" */}
                            {/* placeholder="Unesite broj sati" */}
                            {/* value={this.state.lectureNumber} */}
                            {/* name="lectureNumber" */}
                            {/* onChange={(e) => this.setState({ lectureNumber: e.target.value })} */}
                            {/* error={this.state.lectureNumberErr} */}
                            {/* /> */}
                            {/* </Form.Group> */}

                            <Form.Group widths="equal">
                                {/* <Form.Field */}
                                {/* control={Input} */}
                                {/* label="ECTS" */}
                                {/* placeholder="Unesite ECTS bodove" */}
                                {/* value={this.state.ects} */}
                                {/* name="ects" */}
                                {/* onChange={(e) => this.setState({ ects: e.target.value })} */}
                                {/* /> */}
                                <Form.Field>
                                    <label>Napomena</label>
                                    <Form.TextArea
                                        placeholder="Unesite napomenu..."
                                        rows={1}
                                        value={this.state.comment}
                                        onChange={(e) => this.setState({ comment: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Napomena za profesore</label>
                                    <Form.TextArea
                                        placeholder="Unesite napomenu..."
                                        rows={1}
                                        value={this.state.commentForStaff}
                                        onChange={(e) => this.setState({ commentForStaff: e.target.value })}
                                    />
                                </Form.Field>
                            </Form.Group>


                            <Button basic="true" color="blue" onClick={this.closeCreateCourseMode} floated="right">Odustani</Button>
                            <Button
                                color="blue"
                                floated="right"
                                disabled={this.state.disabledButton}
                                onClick={
                                    () => {
                                        this.setState({ disabledButton: true }, () => {
                                        this.createCourse(
                                            this.state.maxNumberOfStudents,
                                            this.state.comment,
                                            this.state.courseCode,
                                            this.state.exerciseNumber,
                                            this.state.lectureNumber,
                                            this.state.ects,
                                            this.state.semesterId,
                                            this.state.commentForStaff
                                        );
                                        });
                                    }
                                }
                            >
                                Kreiraj implementaciju
                            </Button>
                        </Form>
                    </Segment>
                </Segment.Group>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/CreateCourseImplementation/CreateCourse.js